import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEindinsectieInvullen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#A8D3AF"
      fillRule="evenodd"
      d="m20 5 13 10v20H7V15z"
      clipRule="evenodd"
    />
    <path
      fill="#00A75D"
      fillRule="evenodd"
      d="M25.78 16.6c0-.83-.68-1.51-1.51-1.51h-8.54c-.83 0-1.51.68-1.51 1.51s-.68 1.51-1.51 1.51h-1.55c-.61 0-1.11.49-1.11 1.11V30.9c0 .61.49 1.11 1.11 1.11h17.68c.61 0 1.11-.49 1.11-1.11V19.22c0-.61-.49-1.11-1.11-1.11h-1.55c-.83 0-1.51-.68-1.51-1.51"
      clipRule="evenodd"
    />
    <path
      fill="#A8D3AF"
      d="M20 30.17a5.11 5.11 0 1 0 0-10.22 5.11 5.11 0 0 0 0 10.22"
    />
    <path
      fill="#00A75D"
      d="M17.52 27.54c-3.01-2.03-.96-6.92 2.57-6.59 1.05.06 2.05.63 2.57 1.45-3.54-2.32-7.46 1.6-5.14 5.14"
    />
    <path
      fill="#A8D3AF"
      d="M24.65 20.16a1.01 1.01 0 1 0 0-2.02 1.01 1.01 0 0 0 0 2.02"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEindinsectieInvullen);

export default ForwardRef;
